import { useState } from 'react';
import { motion } from 'framer-motion';

const technologyStacks = [
  {
    title: 'Generative AI Models',
    tools: [
      { name: 'GPT-3', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/gpt.Woblo.png?updatedAt=1789040429782' },
      { name: 'GPT-4', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/gpt.Woblo.png?updatedAt=1789040429782' },
      { name: 'DALL-E', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/gpt.Woblo.png?updatedAt=1789040429782' },
      { name: 'DeepArt', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/deep-art.Woblo.webp?updatedAt=1789040429789' },
      { name: 'DeepDream', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/deepdream.Woblo.png?updatedAt=1789040429744' },
    ],
  },
  {
    title: 'Libraries',
    tools: [
      { name: 'TensorFlow', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/tensorflow.Woblo.webp?updatedAt=1789040429809' },
      { name: 'Sonnet', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/sonnet.Woblo.webp?updatedAt=1789040429831' },
      { name: 'Tensor2Tensor', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/tensorflow.Woblo.webp?updatedAt=1789040429809' },
      { name: 'Scikit-Learn', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/scikit-learn.Woblo.webp?updatedAt=1789040429805' },
      { name: 'OpenCV', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/opencv.Woblo.webp?updatedAt=1789040429801' },
      { name: 'Opennn', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/openn.Woblo.webp?updatedAt=1789040429817' },
      { name: 'Neuroph', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/neuroph.Woblo.webp?updatedAt=1789040429749' },
      { name: 'Tf-slim', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/tensorflow.Woblo.webp?updatedAt=1789040429809' },
    ],
  },
  {
    title: 'Deep Learning Frameworks',
    tools: [
      { name: 'PyTorch', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/pytorch.Woblo.webp?updatedAt=1789040429792' },
      { name: 'Mexnet', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/mxnet.Woblo.webp?updatedAt=1789040429790' },
      { name: 'NVIDIA', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/nvidia.Woblo.webp?updatedAt=1789040429840' },
      { name: 'Caffe 2', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/caffe2.Woblo.webp?updatedAt=1789040429760' },
      { name: 'Chainer', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/chainer.Woblo.webp?updatedAt=1789040429778' },
      { name: 'TensorFlow', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/tensorflow.Woblo.webp?updatedAt=1789040429809' },
    ],
  },
  {
    title: 'Modules/Toolkits',
    tools: [
      { name: 'Kurento', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/kurento.Woblo.png?updatedAt=1789040429825' },
      { name: 'Core ML', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/core-ml.Woblo.png?updatedAt=1789040429780' },
      { name: 'Microsoft Cognitive Toolkit', image: 'https://ik.imagekit.io/7wqj9br0b/PTKCS/Services/Gen%20AI/Tools/microsoft-toolkit.Woblo%20(1).png?updatedAt=1789040429810' },
    ],
  },
  {
    title: 'Cloud',
    tools: [
      { name: 'AWS', image: 'https://www.xicom.biz/images/technologies-logo/aws.webp' },
      { name: 'Microsoft Azure', image: 'https://www.xicom.biz/images/technologies-logo/azure.webp' },
      { name: 'Google Cloud', image: 'https://www.xicom.biz/images/technologies-logo/google-cloud.webp' },
    ],
  },
  { title: 'Algorithms', tools: ['Clustering', 'Metric Learning', 'Fewshot Learning', 'Supervised/Unsupervised Learning'].map((name) => ({ name })) },
  { title: 'Neural Networks', tools: ['CNN', 'RNN', 'Manifold Learning', 'Bayesian Network', 'Representation Learning', 'Variational Autoencoders', 'Autoregressive Networks'].map((name) => ({ name })) },
  { title: 'Image Classification Models', tools: ['VGG-16', 'ResNet50', 'Inceptionv3', 'EfficientNet'].map((name) => ({ name })) },
];

export default function TechnologyStacks() {
  const [activeTechnology, setActiveTechnology] = useState(0);
  const active = technologyStacks[activeTechnology];

  return <section className="px-6 py-24 lg:px-10 lg:py-12" style={{ background: '#FFFFFF' }}>
    <div className="mx-auto max-w-7xl">
      <motion.div initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }} viewport={{ once: true, amount: 0.3 }} className="mx-auto max-w-7xl text-center">
        <h2 className="text-[32px] font-semibold leading-[48px]" style={{ color: '#183762' }}>Latest technology stacks trends we utilize for Generative AI development services</h2>
        <p className="mx-auto mt-7 max-w-7xl text-base text-center font-normal leading-[27px]" style={{ color: '#212121' }}>At PTKCS, we leverage advanced and innovative technologies to deliver scalable, efficient and intelligently tailored Generative AI solutions for modern business needs.</p>
      </motion.div>
      <div className="mt-16 grid overflow-hidden md:grid-cols-2" style={{ minHeight: '396px' }}>
        <nav className="overflow-hidden px-8 py-8 sm:px-12 lg:px-14" style={{ background: '#092952' }} aria-label="Technology stack categories">
          <div className="max-h-[330px] overflow-y-auto pr-4" style={{ scrollbarColor: '#FFFFFF #48688D', scrollbarWidth: 'thin' }}>
            {technologyStacks.map((stack, index) => <button key={stack.title} type="button" onClick={() => setActiveTechnology(index)} className="flex w-full items-center gap-5 border-b py-6 text-left transition-colors" style={{ borderColor: 'rgba(255,255,255,0.2)', color: activeTechnology === index ? '#FFFFFF' : 'rgba(255,255,255,0.55)' }} aria-selected={activeTechnology === index}>
              <span className="shrink-0 text-base font-semibold">{String(index + 1).padStart(2, '0')}.</span>
              <span className="text-base font-semibold sm:text-lg">{stack.title}</span>
            </button>)}
          </div>
        </nav>
        <div className="p-6 sm:p-8 lg:p-10" style={{ background: '#F5F5F5' }} role="tabpanel" aria-label={active.title}>
          <div className="grid gap-4 sm:grid-cols-2">
            {active.tools.map((tool) => <div key={tool.name} className="flex min-h-[54px] items-center gap-4 border px-5 py-3" style={{ borderColor: '#D8DEE5', background: '#FFFFFF' }}>
              {tool.image ? <img src={tool.image} alt="" className="h-7 w-7 shrink-0 object-contain" /> : <span className="h-7 w-7 shrink-0" aria-hidden="true" />}
              <span className="text-sm font-medium sm:text-base" style={{ color: '#092952' }}>{tool.name}</span>
            </div>)}
          </div>
        </div>
      </div>
    </div>
  </section>;
}
